export const QuickActionTypes = {
  ADDON: "addonString",
  MULTI_ADDON: "capitalCaseMultiOrderAddOnsString",
  MFAQ_FOLLOW_UP: "mfaqQuestionString",
  PRODUCT_QUALITY: "capitalCaseProductQualityReportString",
  PRODUCT_ISSUE: "productString",
  SHOPPING_TOOL: "shoppingToolSurveyString",
  TESTBUY_FOLLOW_UP: "capitalCaseTestBuyString",
  CUSTOM: "capitalCaseCustomString",
};
